import React, {useState, useEffect } from 'react';
import {Row, Col, Table} from 'antd';
import {getMethod} from '../services/methods';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import * as dayjs from 'dayjs'
import CompletedReport from "../components/completed-report";

const totalTaskColumns = [
    {
        title: 'Şehir',
        dataIndex: '_id',
        key: '_id'
    },
    {
        title: 'Ziyaret Sayısı',
        dataIndex: 'taskCount',
        key: 'taskCount'
    },
];

export default function StateReport(props) {
    return (<CompletedReport type={'county'}/>)
}
